module.exports = __webpack_public_path__ + "img/wiping-swipe-for-floors-green.f0aebd40.svg";